export const mockProjects = [
  {
    id: "1",
    title: "د نجونو د زده کړې نوښت",
    category: "Education",
    description: "په کابل او کندهار ولایتونو کې د نجونو لپاره د سکالرشیپونو، ښوونځي توکو او خوندي زده کړې چاپیریال برابرول.",
    image: "https://readdy.ai/api/search-image?query=Afghan%20girls%20studying%20in%20a%20bright%20classroom%20with%20books%20and%20colorful%20supplies%2C%20warm%20natural%20lighting%2C%20hopeful%20atmosphere%2C%20clean%20simple%20background&width=800&height=500&seq=proj1&orientation=landscape",
    raised: 48200,
    goal: 60000,
    status: "active",
    location: "کابل او کندهار",
    beneficiaries: 320,
  },
  {
    id: "2",
    title: "د پاکو اوبو لاسرسي پروګرام",
    category: "Infrastructure",
    description: "په کلیوالي افغان کلیو کې د اوبو پاکولو سیستمونه او څاه ګانې نصبول ترڅو زرګونو کورنیو ته پاک څښاک اوبه برابرې شي.",
    image: "https://readdy.ai/api/search-image?query=Clean%20water%20well%20installation%20in%20a%20rural%20Afghan%20village%2C%20community%20members%20gathering%2C%20bright%20sunny%20day%2C%20simple%20background&width=800&height=500&seq=proj2&orientation=landscape",
    raised: 31500,
    goal: 45000,
    status: "active",
    location: "هلمند ولایت",
    beneficiaries: 1200,
  },
  {
    id: "3",
    title: "ګرځنده روغتیايي مرکزونه",
    category: "Healthcare",
    description: "د رضاکار ډاکټرانو لخوا سمبال ګرځنده طبي واحدونه ځای پرځای کول ترڅو په بې وزلو ټولنو کې لومړنۍ روغتیايي خدمتونه وړاندې شي.",
    image: "https://readdy.ai/api/search-image?query=Mobile%20medical%20clinic%20in%20Afghanistan%2C%20doctor%20treating%20patients%20outdoors%2C%20clean%20white%20medical%20tent%2C%20warm%20compassionate%20atmosphere&width=800&height=500&seq=proj3&orientation=landscape",
    raised: 22800,
    goal: 35000,
    status: "active",
    location: "ننګرهار ولایت",
    beneficiaries: 850,
  },
  {
    id: "4",
    title: "مسلکي زده کړو مرکزونه",
    category: "Education",
    description: "بې کاره ځوانانو او ښځو ته د بازار وړ مهارتونو — خیاطي، ترکاڼي، کمپیوټر او کرنې — زده کړه ورکول.",
    image: "https://readdy.ai/api/search-image?query=Afghan%20youth%20learning%20vocational%20skills%20in%20a%20training%20workshop%2C%20sewing%20machines%20and%20tools%2C%20focused%20students%2C%20bright%20indoor%20setting&width=800&height=500&seq=proj4&orientation=landscape",
    raised: 18900,
    goal: 28000,
    status: "active",
    location: "هرات",
    beneficiaries: 210,
  },
  {
    id: "5",
    title: "د کډوالو د بیا میشتیدنې ملاتړ",
    category: "Community",
    description: "په کاناډا کې افغان کډوالو کورنیو سره د ژبې ټولګیو، کور موندنې مرستې او کارموندنې لارښوونې له لارې یوځای کېدو کې مرسته.",
    image: "https://readdy.ai/api/search-image?query=Afghan%20refugee%20family%20in%20Canada%20receiving%20community%20support%2C%20warm%20welcoming%20environment%2C%20multicultural%20setting%2C%20hopeful%20expressions&width=800&height=500&seq=proj5&orientation=landscape",
    raised: 55000,
    goal: 55000,
    status: "completed",
    location: "ټورنټو او اوټاوا",
    beneficiaries: 480,
  },
  {
    id: "6",
    title: "د ژمي مرستې کمپاین",
    category: "Humanitarian",
    description: "د افغانستان په سختو ژمي کې زیان منونکو کورنیو ته د ګرمو جامو، کمپلو او خوراکي توکو ویش.",
    image: "https://readdy.ai/api/search-image?query=Humanitarian%20aid%20distribution%20in%20Afghanistan%2C%20volunteers%20handing%20out%20warm%20blankets%20and%20food%20packages%20to%20families%20in%20winter%2C%20compassionate%20scene&width=800&height=500&seq=proj6&orientation=landscape",
    raised: 12400,
    goal: 20000,
    status: "active",
    location: "څو ولایتونه",
    beneficiaries: 600,
  },
];

export const mockStats = [
  { label: "ملاتړ شوي زده کوونکي", value: "۲،۵۰۰+" },
  { label: "فعالې پروژې", value: "۱۵" },
  { label: "د اغیزې کلونه", value: "۸" },
  { label: "رضاکاران", value: "۳۴۰+" },
];